
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TDashboardRegionFilter, TDashboardRegionFilterFullFilter } from '@/modules/ves/types/regionDashboards';
  import { getFilteredRegionsForUserRole } from '@/modules/ves/utils/getFilteredRegionsForUserRole';

  import DashboardsCardFilterBlock from '../dashboards-card-filter-block/DashboardsCardFilterBlock.vue';
  import { TSelectConfig } from '../dashboards-card-filter-block/types';
  import RegionDashboardsExportButtons from './RegionDashboardsExportButtons.vue';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  export default defineComponent({
    name: 'RegionDashboardsMainFilterBlock',
    components: {
      DashboardsCardFilterBlock,
      RegionDashboardsExportButtons,
    },
    emits: {
      changeFilter: (value: TDashboardRegionFilterFullFilter) => value,
      downloadPDF: () => true,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionFilterFullFilter>,
        required: true,
      },
      plannedEventsRegionRfIds: {
        type: Array as PropType<number[]>,
        default: () => [],
      },
      countryId: {
        type: Number,
        required: false,
      },
    },
    created() {
      this.getRegionsSearchId();
    },
    computed: {
      ...mapGetters({
        regionsList: DIRECTIVES_GETTERS_NAME.getRegionsSearchIdList,
      }),
      getSelectConfig(): TSelectConfig<TDashboardRegionFilter> {
        return {
          filterKey: 'regionRfId',
          options: this.getRegionOptions,
          title: 'Карточка субъекта РФ',
        };
      },
      getRegionOptions() {
        const filteredData = getFilteredRegionsForUserRole(this.regionsList);

        return filteredData.map((i: { id: number; name: string }) => ({ value: i.id, label: i.name }));
      },
    },
    methods: {
      ...mapActions({
        getRegionsSearchId: DIRECTIVES_ACTIONS_NAME.getRegionsSearchId,
      }),
      changeFilter(filter: TDashboardRegionFilter) {
        this.$emit('changeFilter', filter);
      },
    },
  });
